var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1 17.6001C19.8913 17.6001 16.8135 18.875 14.5442 21.1443C12.2749 23.4136 11 26.4914 11 29.7001V31.9001C11 32.1916 11.1155 32.4721 11.3223 32.6778C11.528 32.8846 11.8085 33.0001 12.1 33.0001H34.1C34.3915 33.0001 34.672 32.8846 34.8777 32.6778C35.0845 32.4721 35.2 32.1916 35.2 31.9001V29.7001C35.2 26.4914 33.9251 23.4136 31.6558 21.1443C29.3865 18.875 26.3087 17.6001 23.1 17.6001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7 22C3.4474 22 0 25.4474 0 29.7V31.9C0 32.5072 0.4928 33 1.1 33H8.9892C8.8649 32.6502 8.8 32.2784 8.8 31.9V29.7C8.8 27.1876 9.4611 24.7434 10.6865 22.6006C9.768 22.2134 8.7593 22 7.7 22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5002 22C37.4409 22 36.4322 22.2134 35.5137 22.6006C36.7391 24.7434 37.4002 27.1876 37.4002 29.7V31.9C37.4002 32.2784 37.3353 32.6502 37.211 33H45.1002C45.7074 33 46.2002 32.5072 46.2002 31.9V29.7C46.2002 25.4474 42.7528 22 38.5002 22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69922 19.7998C4.66322 19.7998 2.19922 17.3358 2.19922 14.2998C2.19922 11.2638 4.66322 8.7998 7.69922 8.7998C10.7352 8.7998 13.1992 11.2638 13.1992 14.2998C13.1992 17.3358 10.7352 19.7998 7.69922 19.7998Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 19.7998C35.464 19.7998 33 17.3358 33 14.2998C33 11.2638 35.464 8.7998 38.5 8.7998C41.536 8.7998 44 11.2638 44 14.2998C44 17.3358 41.536 19.7998 38.5 19.7998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1004 15.4C18.8511 15.4 15.4004 11.9493 15.4004 7.7C15.4004 3.4507 18.8511 0 23.1004 0C27.3497 0 30.8004 3.4507 30.8004 7.7C30.8004 11.9493 27.3497 15.4 23.1004 15.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.bbc5084ed7567b132714d2db9c1501ee.svg";
export { ForwardRef as ReactComponent };